import React from 'react';
import Template from './Template';

const Debug: React.FunctionComponent = () => {
  return <Template />;
};

export default Debug;
